import { Skeleton } from "@/components/ui/skeleton";

export default function AuthButtonSkeleton() {
  return (
    <Skeleton
      className="h-9 w-20 rounded-md"
      data-testid="auth-button-skeleton"
    />
  );
}
